import { http } from "@/http/http.js";
export default {
  //添加班组信息
  addGroupInfo(params) {
    return http.post("/web/groupManage/addGroupInfo", params);
  },
  //获取班组信息列表
  getGroupInfo(params) {
    return http.post("/web/groupManage/getGroupInfo", params);
  },
  //删除班组信息
  deleteGroupInfo(params) {
    return http.post("/web/groupManage/deleteGroupInfo", params);
  },
  //校验班组名称是否存在
  checkGroupName(params) {
    return http.post("/web/groupManage/checkGroupName", params);
  },
  //根据班组ID和员工信息查询人员信息
  getEmployeeByGroupId(params) {
    return http.post("/web/groupManage/getEmployeeByGroupId", params);
  },
  //修改班组信息
  updateGroupInfo(params) {
    return http.post("/web/groupManage/updateGroupInfo", params);
  },
  //人员分页列表
  getEmployeeList(params) {
    return http.post("/web/employee/list", params);
  },
  //新增班组人员
  addGroupEmployee(params) {
    return http.post("/web/groupManage/addGroupEmployee", params);
  },
  //根据班组ID和人员ID移除人员
  deleteEmployeeByGroupId(params) {
    return http.post("/web/groupManage/deleteEmployeeByGroupId", params);
  },
};
